import axios from "axios";
import config from "app/api/axiosConfig";
import { IServiceCategory } from "app/api/types";

export default (token: string, data: IServiceCategory) =>
  axios.post(
    `${process.env.REACT_APP_API_HOST}/admin/categories`,
    data,
    config(token)
  );
